<script>
import baseList from "@/views/components/base/baseList.vue";
import { Avatar, Button, Card, Col, Row } from "view-design";
import you from "@/assets/icon/you.png";
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "water_comment",
        key: "id",
        url: {},
        output: false,
      },
      data: {},
      menus: [
        {
          label: "评论列表",
          name: "water_comment",
          auth: "/admin/water_comment/lists",
          //   badge: { mname: "statisticsstats", scene: "recycle_notverify" },
        },
      ],
      actions: [],
      tactions: [
        // { label: '导出数据', type: 'success', onClick: this.exportData.bind(this, '商家数据', 0), auth: '/admin/spot/lists' },
        // { label: '导出全部数据', type: 'error', onClick: this.exportData.bind(this, '商家数据', 1), auth: '/admin/spot/lists' },
      ],
      query: {
        model_id: this.$route?.query?.id,
      },
      currentRow: null,
      filters: [
        // { label: "加水人", name: "publish_name", value: "", type: "input" },
      ],
      tableCols: [
        {
          title: "用户",
          key: "publish_name",
          width: 200,
          // align: "center",
          render: (h, { row }) => {
            let uname = row.publish_name;
            let src = row.publish_head;
            let uid = row.user?.uid;
            return h(
              "div",
              {
                style: {
                  height: "34px",
                  lineHeight: "34px",
                  overflow: "hidden",
                },
              },
              [
                h("Avatar", {
                  props: {
                    src: src,
                  },
                  attrs: {
                    title: "UID: " + uid,
                  },
                  style: {},
                }),
                h(
                  "span",
                  {
                    attrs: {
                      title: uname,
                    },
                    style: {
                      marginLeft: "5px",
                      width: "auto",
                      height: "34px",
                      overflow: "hidden",
                    },
                  },
                  uname
                ),
              ]
            );
          },
        },
        {
          title: "时间",
          minWidth: 100,
          key: "create_time",
        },
        {
          title: "内容",
          minWidth: 200,
          key: "content",
        },
        {
          title: "状态",
          align: "center",
          key: "status",
          minWidth: 50,
          switch: true,
          disabled: false,
        },
        {
          title: "操作",
          align: "center",
          minWidth: 100,
          key: "handle",
          fixed: "right",
          handle: ["delete"],
          auth: {
            del: "/admin/water_comment/del",
          },
        },
      ],
    };
  },
  created() {},

  methods: {},
};
</script>
